<script setup lang="ts">
withDefaults(defineProps<{
  copyright?: boolean;
}>(), {
  copyright: true,
});
</script>

<template>
  <div class="grid min-h-full grid-rows-[minmax(0,15%)_auto_auto] justify-items-center gap-y-4 p-4">
    <div class="row-start-1 mb-auto flex w-full min-w-0 justify-center sm:row-start-2">
      <slot />
    </div>
    <div v-if="copyright" class="row-start-3 w-full self-end text-center text-slate-500">
      © 2002-{{ new Date().getFullYear() }} Axure Software Solutions, Inc. |
      <a
        target="_blank"
        href="https://www.axure.com/patents"
      >
        www.axure.com/patents
      </a>
    </div>
  </div>
</template>
